import { useCallback } from 'react'
import { useNavigate } from 'react-router'

/**
 * Custom hook for creating new audience threads
 * Generates a new UUID and navigates to the thread page
 */
export const useCreateNewAudience = () => {
    const navigate = useNavigate()

    const createNewAudience = useCallback(() => {
        const newThreadId = crypto.randomUUID()
        void navigate(`/thread/${newThreadId}`)
    }, [navigate])

    return { createNewAudience }
}
